<h2 mat-dialog-title class="dialog-title">
  Access Control List for value {{  data.value  }} in data type {{  data.dataType  }}
</h2>

<mat-dialog-content>

  <table mat-table [dataSource]="dataSource" class="mat-elevation-z1 full-width-table">

    <ng-container matColumnDef="enable">
      <th mat-header-cell *matHeaderCellDef>Enable</th>
      <td mat-cell *matCellDef="let element">
        <span
          class="clickable"
          [ngClass]="element.read ? 'green-check' : 'red-x'"
          (click)="element.read = !element.read"
        >
          {{ element.read ? "✔" : "✗" }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="profileName">
      <th mat-header-cell *matHeaderCellDef> Profile name </th>
      <td mat-cell *matCellDef="let element"> {{ element.profile }} </td>
    </ng-container>

    <!-- <ng-container matColumnDef="associatedOriginators">
      <th mat-header-cell *matHeaderCellDef> Associated Originators </th>
      <td mat-cell *matCellDef="let element"> {{ element.associatedOriginators }} </td>
    </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="accessDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: accessDisplayedColumns;"></tr>
  </table>
</mat-dialog-content>
     
<mat-dialog-actions class="dialog-actions">
  <button mat-raised-button color="primary" class="circle-btn" (click)="openAddProfileDialog()">
    <mat-icon>add</mat-icon>
  </button>

  <span class="spacer"></span>

  <button mat-raised-button color="primary" (click)="onSave()">Save</button>
  <button mat-raised-button color="primary" (click)="onClose()">Cancel</button>
</mat-dialog-actions>
